<template>
  <figure class="billboard" :class="[type, color, background, productType]">
    <a class="billboard-link" :href="url">
      <div class="billboard-background">
        <slot name="background"></slot>
      </div>
      <div class="product-image product-image--frosted">
        <slot name="image-frosted"></slot>
      </div>
      <div class="product-image">
        <slot name="image"></slot>
      </div>
      <h5><slot name="label"></slot></h5>
      <h3><slot name="title"></slot></h3>
      <slot name="text"></slot>
      <slot name="button"></slot>
    </a>
    <slot name="admin"></slot>
  </figure>
</template>

<script>
export default {
  props: ["type", "color", "background", "image", "url", "productType"],
};
</script>
